import React from "react";
import styled from "styled-components";
import { ImWhatsapp } from "react-icons/im";
import { Link } from "react-router-dom";


export const WppButton = ({ height, text }) => {
  return (
    <Wpp height={height}>
      <a href="https://api.whatsapp.com/send?phone=5511917721058&text=Olá%20Quero%20saber%20mais%20Sobre%20Clínica%20de%20Recuperação">
        <ImWhatsapp />
        {text ? <h1>{text}</h1> : <h1>WHATSAPP</h1>}
      </a>
    </Wpp>
  );
};
const Wpp = styled.button`
  height: ${(props) => props.height + "px"};
  margin: auto;
  padding-top: 2px;
  padding-bottom: 2px;
  background-color: #5d9a2b;
  border-style: none;
  border-radius: 3px;
  width: calc(auto + 5px);
  padding-left: 7%;
  padding-right: 7%;
  a {
    text-decoration: none;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  svg {
    color: #fff;
    height: auto;
    width: auto;
  }
  span {
    width: auto;
  }
  h1 {
    font-family: "Jost", sans-serif;
    font-weight: bold;
    color: #fff;
    line-height: 30%;
    font-size: auto;
    width: auto;
    margin-left: 5px;
  }
  &:hover {
    background-color: #2b5b9a;
  }
`;
